import React from 'react';
import { mockData } from './data';
import { ArrowRightIcon, TrophyIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function CompensationLadder() {
  const {
    tiers
  } = mockData.advancement;
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: 0.6
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col" data-id="element-92">
      <div className="bg-[#0A1F5C] text-white px-5 py-4 flex items-center justify-between gap-3" data-id="element-93">
        <div className="flex items-center gap-3" data-id="element-94">
          <div className="bg-white/15 p-1.5 rounded-full" data-id="element-95">
            <TrophyIcon className="w-4 h-4" data-id="element-96" />
          </div>
          <h2 className="text-base font-bold tracking-wide uppercase" data-id="element-97">
            Your Compensation Tier
          </h2>
        </div>
        <span className="text-[10px] font-bold text-blue-200 bg-white/10 px-2 py-1 rounded uppercase tracking-wider" data-id="element-98">
          Trailing 6 Months
        </span>
      </div>

      <div className="p-6 flex-1 flex flex-col" data-id="element-99">
        <div className="space-y-1.5 mb-5" data-id="element-100">
          {tiers.map((tier, idx) => <div key={idx} className={`flex items-center justify-between px-3 py-2.5 rounded-lg border transition-all ${tier.isCurrent ? 'bg-[#0A1F5C] border-[#0A1F5C] text-white' : 'bg-white border-gray-200 text-[#0A1F5C] hover:border-gray-300'}`} data-id="element-101">
              <div className="flex items-center gap-2.5 min-w-0" data-id="element-102">
                {tier.isCurrent && <span className="bg-white text-[#0A1F5C] text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider shrink-0" data-id="element-103">
                    You are here
                  </span>}
                <span className={`text-sm font-bold tracking-wide ${tier.isCurrent ? 'text-white' : 'text-[#0A1F5C]'}`} data-id="element-104">
                  {tier.range}
                </span>
              </div>
              <div className="flex items-baseline gap-1 shrink-0" data-id="element-105">
                <span className={`text-base font-bold tabular-nums ${tier.isCurrent ? 'text-white' : 'text-[#2563EB]'}`} data-id="element-106">
                  {tier.incentive}
                </span>
                <span className={`text-[10px] font-semibold uppercase tracking-wider ${tier.isCurrent ? 'text-blue-200' : 'text-gray-500'}`} data-id="element-107">
                  {tier.sub}
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-blue-50 rounded-lg p-4 border border-blue-100" data-id="element-108">
          <div className="flex justify-between items-center" data-id="element-109">
            <div data-id="element-110">
              <span className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider block mb-1" data-id="element-111">
                Next Tier Unlock
              </span>
              <span className="text-sm font-bold text-[#2563EB]" data-id="element-112">
                $45 / unit at 25+ loans
              </span>
            </div>
            <div className="text-right" data-id="element-113">
              <span className="text-xl font-bold text-[#0A1F5C] tabular-nums" data-id="element-114">
                1
              </span>
              <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider ml-1" data-id="element-115">
                More Closing
              </span>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-5" data-id="element-116">
          <button type="button" className="w-full group flex items-center justify-between bg-orange-50 hover:bg-orange-100 border border-orange-200 rounded-lg px-4 py-3 transition-colors" data-id="element-117">
            <div className="text-left" data-id="element-118">
              <span className="text-[10px] font-bold text-[#E8801F] uppercase tracking-wider block mb-0.5" data-id="element-119">
                Senior Processor Preview
              </span>
              <span className="text-sm font-semibold text-gray-800" data-id="element-120">
                Top tier becomes{' '}
                <span className="text-[#E8801F] font-bold" data-id="element-121">$55 / unit</span>
              </span>
            </div>
            <ArrowRightIcon className="w-4 h-4 text-[#E8801F] group-hover:translate-x-1 transition-transform" data-id="element-122" />
          </button>
        </div>
      </div>
    </motion.section>;
}